import { forwardRef, type Ref, type SVGProps } from "react";
const IconFlagPointedFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.8 20.4 24.3 13l5.5-6.4a1 1 0 0 0 .1-1A1 1 0 0 0 29 5H6V4a1 1 0 0 0-2 0v5H3a1 1 0 0 0 0 2h1v5H3a1 1 0 0 0 0 2h1v10a1 1 0 0 0 2 0v-6h23a1 1 0 0 0 .8-1.6M8 18H6v-2h2a1 1 0 0 1 0 2m0-7H6V9h2a1 1 0 0 1 0 2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFlagPointedFilledSVG);
ForwardRef.displayName = "IconFlagPointedFilled";
export { ForwardRef as IconFlagPointedFilled };
